import HcpStatCallout from '@/components-hcp/stat-callout';
import styles from './_callouts.module.scss';

export default function HcpVideoCallouts() {
  return (
    <section className={styles.container}>
      <div className="container container--px-16">
        <div className={styles.content}>
          <h2 className={styles.title}>
            PATIENT SATISFACTION WITH CRENESSITY<sup>1</sup>:
          </h2>

          <p className="h4">
            In a survey of 48 adults and 29 caregivers, when asked at the <span className="text-nowrap">end of</span> the open-label extension period<sup>1</sup>:
          </p>

          <div className={styles.callouts}>
            <HcpStatCallout className={styles.callout}>
              <strong>96% of adults and 94% of caregivers of children</strong> prefer a treatment plan with CRENESSITY over one without CRENESSITY.<sup>1</sup>*
            </HcpStatCallout>

            <HcpStatCallout colorTheme="orange" className={styles.callout}>
              <strong>96% of adults and 100% of caregivers of children</strong> were satisfied with taking CRENESSITY.<sup>1&dagger;</sup>
            </HcpStatCallout>
          </div>

          <div className="footnotes">
            <ul>
              <li>
                <span className="hang">*</span>
                <span>
                  Percentages include adult participants and caregivers of pediatric participants from the CAHtalyst<sup>&reg;</sup> trials who &quot;agreed&quot; or &quot;strongly agreed&quot; that they prefer treatment with CRENESSITY over a treatment plan without CRENESSITY in the final treatment satisfaction survey.
                </span>
              </li>
              <li>
                <sup className="hang">&dagger;</sup>
                <span>
                  Percentage includes adult participants and caregivers of pediatric participants from the CAHtalyst<sup>&reg;</sup> trials who rated their level of satisfaction with CRENESSITY as either &quot;moderately satisfied&quot; or &quot;greatly satisfied&quot; in the final treatment satisfaction survey.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
